// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js","348":"5c0b189e"}[chunkId] + "-" + {"125":"7fbb225cbec293766c1d","223":"b7d9050e1d4fc0074a3d","293":"0d3603e626772a18d5e4","348":"f662b09f4885c2cebceb"}[chunkId] + ".js";
};